import {
  type GetContractorBadgeVerificationPhotoUrlResponse,
  getContractorBadgeVerificationPhotoUrlResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { get } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { CONTRACTOR_BADGE_VERIFICATIONS_URL } from "../constants";

function getPhotoUrl(verificationId: string) {
  return `${CONTRACTOR_BADGE_VERIFICATIONS_URL}/${verificationId}/photo-url`;
}

export function useGetBadgeVerificationPhotoUrl(
  verificationId: string | undefined
): UseQueryResult<GetContractorBadgeVerificationPhotoUrlResponse> {
  const url = getPhotoUrl(verificationId ?? "");

  return useQuery({
    queryKey: [url],
    queryFn: async () => {
      const response = await get({
        url,
        responseSchema: getContractorBadgeVerificationPhotoUrlResponseSchema,
      });

      return response.data;
    },
    enabled: isDefined(verificationId),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.BADGE_VERIFICATION_GET_FAILURE,
    },
  });
}
